import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import { Toaster } from "./components/ui/sonner";

import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="App grain min-h-screen flex flex-col">
      {!isAdmin && (
        <div className="bg-ink text-gold/90 h-7 flex items-center ticker-wrap text-[10px] tracking-widest uppercase font-medium">
          <span className="animate-ticker">
            ✦&nbsp;&nbsp;Delivery Charges are Rs. 350 — Enjoy FREE delivery on orders of Rs. 5,000 or more!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;Delivery Charges are Rs. 350 — Enjoy FREE delivery on orders of Rs. 5,000 or more!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;Delivery Charges are Rs. 350 — Enjoy FREE delivery on orders of Rs. 5,000 or more!
          </span>
        </div>
      )}
      {!isAdmin && <Navbar />}
      {isAdmin && (
        <header className="border-b border-gold-soft bg-cream">
          <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center">
            <a href="/" className="font-serif italic text-2xl text-ink">MZ <span className="eyebrow ml-2">Scents Admin</span></a>
          </div>
        </header>
      )}
      <main className="flex-1">{children}</main>
      {!isAdmin && <Footer />}
      <CartDrawer />
      <Toaster position="top-center" />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/shop/:gender" element={<ShopPage />} />
              <Route path="/product/:id" element={<ProductDetailPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
